<template>
	<div class="campusIdManage">

		<div class="breadcrumb">找回学号</div>
		<div class="search">

			<el-select v-model="status">
				<el-option label="全部状态" value='0'></el-option>
				<el-option label="未操作" value='1'></el-option>
				<el-option label="已通过" value='2'></el-option>
				<el-option label="未通过" value='3'></el-option>
			</el-select>

			<el-select v-model="type">
				<el-option label="手机号" value='1'></el-option>
				<el-option label="姓名" value='2'></el-option>
				<el-option label="学号" value='3'></el-option>
			</el-select>

			<div class="el-input">
				<input type="text" :placeholder="placeholder" class="el-input__inner" v-model="keyWord" @keyup.enter="search"></input>
			</div>

			<el-button type="primary" @click="search">搜索</el-button>
		</div>

		<div class="com-list">
			<el-table :data="list" style="overflow-x: auto;">
				<el-table-column prop="index" label="序号" width='80px;'>
				</el-table-column>
				<el-table-column prop="name" label="姓名">
				</el-table-column>
				<el-table-column prop="phone" label="手机号">
				</el-table-column>
				<el-table-column prop="campusId" label="找回学号">
				</el-table-column>
				<el-table-column prop="appealTime" label="申请时间">
				</el-table-column>
				<el-table-column label="状态" inline-template>
					<div>
						<span v-if="row.status=='1'">未操作</span>
						<span v-if="row.status=='2'">已通过</span>
						<span v-if="row.status=='3'">未通过</span>
					</div>
				</el-table-column>
				<el-table-column label="操作" inline-template>
					<el-button class="option" type="text" @click="detail(row)">申请详情</el-button>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<el-pagination v-show="this.totalCount > 0" layout="prev, pager, next, jumper" :page-size="20" :current-page="currentPage"
				 :total="totalCount" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				list: [],
				totalCount: 0,
				status: this.$util.getUrlParam("status") || "0",
				type: this.$util.getUrlParam("keyType") || "1",
				keyWord: this.$util.getUrlParam("keyword") || "",
				currentPage: this.$util.getUrlParam("pageNum") * 1 || 1
			};
		},
		mounted() {
			if (this.$util.getUrlParam("pageNum")) {
				setTimeout(() => {
					let currentPage = this.$util.getUrlParam("pageNum") * 1;
					location.href = "#/userM/campusIdManage";
					this.currentPage = currentPage;
					this.getList();
				}, 100);
			} else {
				this.getList();
			}
		},
		computed: {
			placeholder() {
				if (this.type === "1") {
					return "请输入手机号";
				} else if (this.type === "2") {
					return "请输入姓名";
				} else {
					return "请输入学号";
				}
			}
		},
		methods: {
			search() {
				this.getList();
			},
			detail(row) {
				let params = {
					id: row.id,
					status: this.status,
					pageNum: this.currentPage,
					keyType: this.keyType,
					keyword: encodeURI(this.keyWord.trimLeft())
				};
				this.$util.refreshTo("/#/userM/campusIdDetail", params);
			},
			//获取找回学号信息列表
			getList() {
				let url = this.$util.domain + "/adminapi/v3/user/campusidfindback/list";
				//0,忽略关键字;
				let keyType = this.keyWord ? this.type * 1 : 0;
				this.$http({
					url,
					method: "POST",
					body: JSON.stringify({
						keyType,
						status: this.status * 1,
						keyword: this.keyWord,
						pageSize: 20,
						pageNum: this.currentPage
					})
				}).then((response) => {
					this.list = [];
					if (response.data.error == 10000) {
						let dataList = response.data.data.dataList;
						this.totalCount = response.data.data.totalCount;
						if (dataList) {
							if (dataList.length > 0) {
								dataList.forEach((item, index) => {
									this.list.push({
										index: index + 1,
										name: item.name,
										phone: item.phone,
										campusId: item.campusId,
										appealTime: new Date(item.appealTime).format("yyyy/MM/dd"),
										status: item.status,
										id: item.id
									});
								});
							}
						}
					} else {
						this.$util.errorMsg(response.data.message);
					}
				}, (response) => {
					this.$util.errorMsg(response.data.message);
				});
			},
			//请求分页数据
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			}
		}
	};
</script>
<style scoped>
	.campusIdManage .el-select {
		display: inline-block;
	}

	.campusIdManage .el-input {
		display: inline-block;
        width: auto;
	}

	.campusIdManage .el-button {
		display: inline-block;
	}

	.campusIdManage .el-button+.el-button {
		margin-left: 0;
	}

	.search {
		margin-left: 30px;
		margin-bottom: 20px;
	}

	.el-dialog__body p {
		line-height: 38px;
	}
</style>


// WEBPACK FOOTER //
// campusIdManage.vue?ffacbc76